import { render, staticRenderFns } from "./problem.vue?vue&type=template&id=d9a29cde&scoped=true"
import script from "./problem.vue?vue&type=script&lang=js"
export * from "./problem.vue?vue&type=script&lang=js"
import style0 from "./problem.vue?vue&type=style&index=0&id=d9a29cde&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a29cde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9a29cde')) {
      api.createRecord('d9a29cde', component.options)
    } else {
      api.reload('d9a29cde', component.options)
    }
    module.hot.accept("./problem.vue?vue&type=template&id=d9a29cde&scoped=true", function () {
      api.rerender('d9a29cde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/record/calssModule/problem.vue"
export default component.exports